import { useEffect, useState } from "react";
import { Button, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

function NNLeaseMarketing(props) {
  const { toggle, agreementValue, setAgreementValue } = props;
  const [approve, setApprove] = useState(agreementValue === "yes");
  const [reject, setReject] = useState(agreementValue === "no");
  let classes = "checkmark";

  const handleApproveChange = () => {
    setApprove(!approve);
    if (!approve) {
      setReject(false);
    }
  };

  const handleRejectChange = () => {
    setReject(!reject);
    if (!reject) {
      setApprove(false);
    }
  };

  useEffect(() => {
    setAgreementValue(approve ? "yes" : reject ? "no" : undefined);
  }, [approve, reject]);

  return (
    <div>
      <ModalHeader
        toggle={toggle}
        tag="h6"
        cssModule={{ "modal-title": "w-100 text-center" }}
      >
        Prelucrare date personale in scop de marketing direct de catre NN Lease
      </ModalHeader>
      <ModalBody>
        <div className="pt-3">
          Prin exprimarea acordului de mai jos, ati fost de acord ca NN LEASE
          SRL si/sau partenerii sai sa prelucreze in scop de marketing direct
          [1], inclusiv prin mijloace automate [2] , datele cu caracter personal
          precum: nume, prenume, data nasterii, adresa e-mail, telefon acasa,
          telefon serviciu, telefon mobil.
        </div>
        <div className="pt-3">
          Pentru indeplinirea scopului de marketing direct, NN LEASE SRL (prin
          departamentele specializate) selecteaza si analizeaza [3] una sau mai
          multe dintre datele cu caracter personal mentionate anterior.
        </div>
        <div className="pt-3">
          Prelucrarea de catre parteneri in scop de marketing direct: una sau
          mai multe dintre datele mentionate pot fi comunicate partenerilor NN.
        </div>
        <div className="pt-3">
          Datele personale sunt comunicate in scopuri comerciale catre urmatorii
          parteneri:
          <ul className="pt-3">
            <li>NN Asigurari de Viata S.A.</li>
            <li>NN Pensii SAFPAP S.A.</li>
            <li>NN Asigurari S.A.</li>
          </ul>
        </div>
        <div className="pt-3">
          In cazul in care intervin actualizari ale datelor transmise,
          consimtamantul ramane in vigoare pana la notificarea NN LEASE SRL in
          sens contrar din partea dumneavoastra.
        </div>
        <div className="pt-3">
          Datele cu caracter personal sunt supuse prelucrarii in scop de
          marketing direct pentru o perioada de timp necesara indeplinirii
          acestui scop. Consimtamantul poate fi retras oricand, in mod gratuit,
          printr-o notificare adresata NN LEASE SRL.
        </div>
        <div>
          <div className="row pt-3">
            <div className="col-md-4">
              <div className="checkbox-container checkbox-warning-filled mb-2 pr-4">
                <div className="d-inline-block">
                  <label className="form-check-label checkbox-label d-inline-block">
                    <input
                      type="checkbox"
                      name="approve"
                      className={"form-check-input"}
                      onClick={handleApproveChange}
                      onChange={handleApproveChange}
                      checked={approve}
                      value={approve}
                    />
                    <span className={classes} />
                    <div className="field-label d-inline-block cursor-pointer">
                      Da, sunt de acord
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="checkbox-container checkbox-warning-filled mb-2 pr-4">
                <div className="d-inline-block">
                  <label className="form-check-label checkbox-label d-inline-block">
                    <input
                      type="checkbox"
                      name="reject"
                      className={"form-check-input"}
                      onClick={handleRejectChange}
                      onChange={handleRejectChange}
                      checked={reject}
                      value={reject}
                    />
                    <span className={classes} />
                    <div className="field-label d-inline-block cursor-pointer">
                      Nu, nu sunt de acord{" "}
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="pt-3">
          <a
            href="https://www.nn.ro/prelucrare-date"
            target="_blank"
            rel="noopener noreferrer"
          >
            [1]
          </a>{" "}
          Marketing direct presupune transmiterea de oferte comerciale,
          newslettere, invitatii la campanii si altele asemenea. Spunem in
          masura in care ati fost de acord, intrucat daca v-ati exprimat
          dezacordul, datele dvs nu vor fi prelucrate in scop de marketing
          direct.
        </div>
        <div className="pt-3">
          <a
            href="https://www.nn.ro/prelucrare-date"
            target="_blank"
            rel="noopener noreferrer"
          >
            [2]
          </a>{" "}
          Adica prin folosirea unor sisteme, aplicatii
        </div>
        <div className="pt-3">
          <a
            href="https://www.nn.ro/prelucrare-date"
            target="_blank"
            rel="noopener noreferrer"
          >
            [3]
          </a>{" "}
          Selectia si analiza nu sunt scopuri diferite de scopul initial, nici
          operatiuni de prelucrare de sine-statatoare, ci modalitati prin care
          se realizeaza scopul de marketing direct. De exemplu, pentru ofertare,
          intern este selectat un anumit public tinta, apoi se analizeaza
          profilul pentru a putea oferta potrivit nevoilor persoanei vizate.
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Închide
        </Button>
      </ModalFooter>
    </div>
  );
}

export default NNLeaseMarketing;
